import { ReducerUtil } from 'doctivity-shared/utils';
import { startOfDay, startOfMonth, differenceInDays, differenceInMonths, parse, parseISO, format, getDate } from 'date-fns';
import {
  DateUtil,
  EncounterTypeUtil,
} from 'doctivity-shared/utils';
import { ProviderNotesUtil } from 'utils';
//import { success } from 'redux-saga-requests';

// Fixed reference so date-fns parse() doesn't inherit today's day/time for partial formats (e.g. 'yyyyMM').
const PARSE_REF = new Date(2000, 0, 1);

export const analytics = (state = {}, action = null) => {
  if (action.type.startsWith('ANALYTICS_')) {
    let type = action.type;
    let storeId = action.store_id;
    if (action.meta && action.meta.requestAction) {
      type = action.meta.requestAction.type;
      storeId = action.meta.requestAction.store_id;
    }
    const field = storeId || type.substring(10);
    
    // FIX: Get data from the correct location in redux-saga-requests v0.27
    const actionData = action.response?.data ?? action.data;
    
    let result;
    if (Array.isArray(actionData)) {
      result = ReducerUtil.reduceListGet(state, action, type, field);
    } else if (Number.isInteger(actionData)) {
      result = ReducerUtil.reduceQuery(state, action, type, field);
    } else {
      result = ReducerUtil.reduceTableGet(state, action, type, field);
    }
    if (result.actionConsumed) {


      if (action.type === 'ANALYTICS_PROVIDER_COMMENTS_PER_DAY') {
        result.state.seriesActivityNotes = [];
        result.state.activityNotesPerDay = result.state.PROVIDER_COMMENTS_PER_DAY;
      } else if (action.type === 'ANALYTICS_PROVIDER_COMMENTS_PER_DAY_SUCCESS') {

        let dateUnits = action.meta.requestAction.request.data.dateUnits;
        let startDate = action.meta.requestAction.request.data.filter.comment_date.$gte;
        let endDate = action.meta.requestAction.request.data.filter.comment_date.$lte;
        
        // convert the dates back to local
        startDate = new Date(`${startDate}`);
        endDate = new Date(`${endDate}`);

        result.state.activityNotesPerDay = result.state.PROVIDER_COMMENTS_PER_DAY;

        // Category year is needed to calculate series, so we will reformat after
        let categories = DateUtil.listUnitsBetween(startDate, endDate, dateUnits);
        const startDay = dateUnits === 'days' ? startOfDay(startDate) : startOfMonth(startDate);

        // create empty series
        const seriesByType = {}; 
        EncounterTypeUtil.getAllWithUnspecified().forEach((type) => {
          seriesByType[type.id || 0] = {
            name: type.name,
            data: Array(categories.length).fill(0),
          };
        });
       
        let totalActivityNotes = 0;
        result.state.activityNotesPerDay?.data.forEach((notes) => {
          let index;
          if (dateUnits === 'days') {
            const day = parse(`${notes.encounter_date}${String(notes.encounter_date_day).padStart(2, '0')}`, 'yyyyMMdd', PARSE_REF);
            index = differenceInDays(day, startDay);
          } else { // months
            // Convert number to string for proper parsing with format
            const month = parse(String(notes.encounter_date), 'yyyyMM', PARSE_REF);
            index = differenceInMonths(month, startDay);
          }
          
          // Ensure index is within bounds
          if (index >= 0 && index < categories.length) {
            seriesByType[notes.encounter_type_id || 0].data[index] += notes.activity_notes;
          }
          totalActivityNotes += notes.activity_notes;

        })
        result.state.totalActivityNotes = totalActivityNotes; 

        let series = [];
        

        series = Object.keys(seriesByType).map((typeId) => {
          return seriesByType[typeId];
        });
        result.state.seriesActivityNotes = series;

        categories = categories?.map((date) =>
          format(parseISO(date), dateUnits === 'days' ? 'MMM dd' : 'MMM yy')
        );
        result.state.categories = categories;

      } else if ( action.type ==='ANALYTICS_PROVIDER_COMMENTS_TAGGED_PER_DAY') {
        result.state.seriesActivityNotesTagged = [];
        result.state.activityNotesTaggedPerDay = result.state.PROVIDER_COMMENTS_TAGGED_PER_DAY;
      
      } else if ( action.type === 'ANALYTICS_PROVIDER_COMMENTS_TAGGED_PER_DAY_SUCCESS') {
        let dateUnits = action.meta.requestAction.request.data.dateUnits;
        let startDate = action.meta.requestAction.request.data.filter.comment_date.$gte;
        let endDate = action.meta.requestAction.request.data.filter.comment_date.$lte;

        // convert the dates back to local
        startDate = new Date(`${startDate}`);
        endDate = new Date(`${endDate}`);


        let types = action.meta.requestAction.request.data.types;

        result.state.activityNotesTaggedPerDay = result.state.PROVIDER_COMMENTS_TAGGED_PER_DAY;

        // Category year is needed to calculate series, so we will reformat after
        let categories = DateUtil.listUnitsBetween(startDate, endDate, dateUnits);
        const series = types.map((type) => {
          const name = ProviderNotesUtil.formatCountTypeForDisplay(type);
    
          return {
            name,
            data: categories.map((category) => {
              const categoryDate = parseISO(category);
              const formattedCategory = parseInt(format(categoryDate, 'yyyyMM'));
              const formattedDay = getDate(categoryDate);
              const taggedPerDayByTypeOnDate =
                result.state.activityNotesTaggedPerDay.data?.filter((notes) => {
                  if (dateUnits === 'days') {
                    return (
                      notes.encounter_date === formattedCategory &&
                      notes.encounter_date_day === formattedDay
                    );
                  }
    
                  return notes.encounter_date === formattedCategory;
                });
    
              return (
                taggedPerDayByTypeOnDate
                  ?.map((notes) => notes[type])
                  ?.reduce((notes, sum) => sum + notes, 0) || 0
              );
            }),
          };
        });
    
        result.state.seriesActivityNotesTagged = series;

        categories = categories?.map((date) =>
          format(parseISO(date), dateUnits === 'days' ? 'MMM dd' : 'MMM yy')
        );
        result.state.categoriesTagged = categories;
    
      }
      return result.state;
    }

  }

  
  return state;
};